import { DateForPmis, Pmis3JsonHelper } from '@pmis3/utils';

export class DataAccessHelper {
    static toHttpData(dataP: any): object | undefined {
        if (!dataP) return undefined;

        const data = Pmis3JsonHelper.DeepCopy(dataP);
        if (!data || data instanceof Date) return data;

        return this._prepareHttpData(data);
    }

    private static _prepareHttpData(data: any): object | undefined {
        if (data instanceof Array)
            data.forEach((d) => this._prepareHttpData(d));
        else if (data instanceof Object)
            Object.keys(data).forEach((k) => {
                const dk = data[k];
                if (
                    k === 'jData' ||
                    k === 'createdByUser' ||
                    k === 'updatedByUser' ||
                    k === 'viewData'
                ) {
                    if (k === 'jData') {
                        this._prepareHttpData(dk);
                        data.jsonData = dk
                            ? JSON.stringify(dk)
                            : data.jsonData || '{}';
                    }
                    data[k] = undefined;
                } else if (dk instanceof Date)
                    data[k] = this._preparePostDataForDate(dk);
                else if (dk instanceof Object) this._prepareHttpData(dk);
            });
        return data;
    }

    static _preparePostDataForDate(dt: Date): DateForPmis | undefined {
        if (!dt) {
            return undefined;
        }

        let dt2: DateForPmis;
        if (dt instanceof DateForPmis) dt2 = dt;
        else dt2 = new DateForPmis(dt);
        dt2.toLocal();
        return dt2;
    }
}
